import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import Table from 'react-bootstrap/Table';
import SystemAccountsHeadRow from './components/SystemAccountsHeadRow';
import SystemAccountsTableRow from './components/SystemAccountsTableRow';
import PopUpUpdateSystemAccountIbanScheme from 'components/PopUpScheme/PopUpUpdateSystemAccountIbanScheme';
import i18nContext from 'components/i18n-context';
import Loader from 'components/Loader';
import Button from 'uikit/Button/Button';
import { Container } from 'uikit/Container/Container';
import { PopUp } from 'uikit/PopUp/PopUp';
import './SystemAccountsTable.scss';

const popUpInitialData = {
  isShowPopUp: false,
  currentIban: '',
  title: '',
  inputLabel: '',
  inputPlaceholder: '',
  onCancel: () => {},
  onConfirm: () => {}
};

const SystemAccountsTable = ({ accountsStore }) => {
  const i18n = useContext(i18nContext);
  const location = useLocation();
  const [popUpData, setPopUpData] = useState(popUpInitialData);

  useEffect(() => {
    if (accountsStore.isInitialized) {
      accountsStore.resetAccountsStore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (!accountsStore.isInitialized) {
      accountsStore.getSystemAccounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountsStore.isInitialized]);

  const resetPopUpData = () => {
    setPopUpData(popUpInitialData);
  };

  const handleUpdateSystemAccountIban = async (systemAccountNumber, systemAccountIban) => {
    setPopUpData({
      isShowPopUp: true,
      currentIban: systemAccountIban,
      title: i18n.getMessage('systemAccounts.updateIbanModal.title'),
      inputLabel: i18n.getMessage('systemAccounts.updateIbanModal.input.iban.label'),
      inputPlaceholder: i18n.getMessage('systemAccounts.updateIbanModal.input.iban.placeholder'),
      onConfirm: async (data) => {
        await accountsStore.updateSystemAccountIban(systemAccountNumber, data);
        resetPopUpData();
      },
      onCancel: resetPopUpData
    });
  };

  if (!accountsStore.isInitialized) {
    return <Loader className={'application-loader'} />;
  }

  return (
    <Container className={'system-accounts-container'} header={i18n.getMessage('container.systemAccounts')}>
      <div className={'system-accounts-actions-wrapper'}>
        <Button
          className={'system-accounts-button'}
          size={'medium'}
          type={'primary'}
          onClick={accountsStore.handleExportSystemAccounts}
          isDisabled={!accountsStore.isInitialized || accountsStore.isLoadingTransitAccountsBalancesCsv}
        >
          {accountsStore.isLoadingTransitAccountsBalancesCsv ? (
            <Loader />
          ) : (
            i18n.getMessage('systemAccounts.button.transitAccountsCsv')
          )}
        </Button>
      </div>

      <Table responsive>
        <thead>
          <SystemAccountsHeadRow />
        </thead>
        <tbody>
          {accountsStore.systemAccounts &&
            accountsStore.systemAccounts.length > 0 &&
            accountsStore.systemAccounts.map((systemAccount, index) => (
              <SystemAccountsTableRow
                key={index}
                type={'list'}
                isLoading={accountsStore.isLoading}
                systemAccountData={systemAccount}
                handleOpenUpdateIbanModal={handleUpdateSystemAccountIban}
              />
            ))}
        </tbody>
      </Table>

      <PopUp alignOnCenter show={popUpData.isShowPopUp}>
        <PopUpUpdateSystemAccountIbanScheme
          isLoading={accountsStore.isLoading}
          currentIban={popUpData.currentIban}
          title={popUpData.title}
          inputLabel={popUpData.inputLabel}
          inputPlaceholder={popUpData.inputPlaceholder}
          onClose={popUpData.onCancel}
          onConfirm={popUpData.onConfirm}
        />
      </PopUp>
    </Container>
  );
};

SystemAccountsTable.propTypes = {
  accountsStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  accountsStore: stores.accountsStore
}))(observer(SystemAccountsTable));
